import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { ScannerPopupProps } from '../containers/ConnectedScanner'
import Scanner from './Scanner'

const ScannerPopup: React.FC<ScannerPopupProps> = props => {
	const [error, setError] = useState<string>()

	window.searchBarcode = props.searchBarcode

	return (
		<div className="grid">
			<div className="grid__row grid__row--spacing-top-3x grid__row--spacing-bottom-2x">
				<div className="grid__col grid__col--12">
					<div className="title title--align-center">
						<FormattedMessage
							id="scan-barcode"
						/>
					</div>
				</div>
				<div className="grid__row grid__row--spacing-top-3x grid__row--spacing-bottom-2x">
					<div className="grid__col grid__col--12">
						{error ? <p className="title title--error title--align-center">{error}</p> : <Scanner onDetect={barcode => props.searchBarcode(barcode)} onError={err => setError(err)} />}
					</div>
				</div>
			</div>
		</div>


	)
}

export default ScannerPopup
